// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"372":"d078122f","871":"9fd3dfed","873":"396b6c2a","903":"d0835517"}[chunkId] + ".chunk.js");